// @flow

import React from "react";
import Page from "app/utils/Page/Page";
import MaintenancePage from "app/components/organisms/MaintenancePage/MaintenancePage";

type Props = {
  user: AppUser,
  authenticated: boolean
};

export const MAINTENANCE_ID = "maintenance";
export const MAINTENANCE_TITLE = "Site Under Maintenance";
export const MAINTENANCE_DESCRIPTION =
  "The site is currently undergoing maintenance. Please check back soon.";

const MaintenancePageContainer = (props: Props) => (
  <Page
    id={MAINTENANCE_ID}
    title={MAINTENANCE_TITLE}
    description={MAINTENANCE_DESCRIPTION}
    noCrawl
  >
    <MaintenancePage user={props.user} authenticated={props.authenticated} />
  </Page>
);

export default MaintenancePageContainer;
